import { render, staticRenderFns } from "./verticalNav.vue?vue&type=template&id=89efb51e"
import script from "./verticalNav.vue?vue&type=script&lang=js"
export * from "./verticalNav.vue?vue&type=script&lang=js"
import style0 from "./verticalNav.vue?vue&type=style&index=0&id=89efb51e&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports